import { getURLParameter } from './functions'

const debug = false; //TODO: set to false for production, true for development
if (debug) console.log('%cDEBUG-MODE', 'color: #ff0000');
else console.log('%cPRODUCATION-MODE', 'color: #00ff00');


/*********************************
 *      GLOBAL VARIABLES
 *********************************/
//TODO: alle Variablen und Konstanten prüfen, erklären und beschreiben wie sie gesetzt werden sollten in welcher Umgebung (Test lokal, cmeassist-dev und cmeassist)

// -- url to node-backend
const backendVersion = 'v2';

// -- aktueller Hostname (z. B. "localhost", "cmeassist-dev.academy2.de", "cmeassist.academy2.de")
const thisUrl = window.location.hostname;
// -- aktuelles Protokoll (z. B. "http:", "https:", "file:")
const thisProtocol = window.location.protocol;

// -- Backend-URL anhand des aktuellen Hostnamens bestimmen
let backendUrl;

if (thisUrl === 'localhost' || thisUrl === '127.0.0.1' || debug === true) {
    // lokal ausgeführt (dev-server ODER lokal geöffneter Build via file://) -> immer lokales Backend verwenden
    backendUrl = `http://localhost:8080/api/${backendVersion}`;
}
else if (thisUrl.includes('dev')) {
    // auf cmeassist-dev -> Dev-Backend verwenden
    backendUrl = `https://cmeassist-dev.academy2.de/backend/api/${backendVersion}`;
}
else {
    // auf cmeassist (Produktion) -> Produktions-Backend verwenden
    backendUrl = `https://cmeassist.academy2.de/backend/api/${backendVersion}`;
}

console.log('thisUrl: ', thisUrl);
console.log('thisProtocol: ', thisProtocol);
console.log('backendUrl: ', backendUrl);

// -- only display questions -> if aussendienst- or questionsOnly-parameter got passed
const onlyQuestions = getURLParameter().ad_email || getURLParameter().onlyQuestions ? true : false;

// -- prüfen ob die App "auf dem Server" läuft (also nicht rein lokal getestet wird)
const isOnServer = (thisUrl !== 'localhost' && thisUrl !== '127.0.0.1' && thisProtocol !== 'file:') || debug;


// -- const suppoert-info
const supportInfo = "<div>+49911 9652250 oder per E-Mail an: <u><a href='mailto:solution@cmeducation.de'>solution@cmeducation.de</a></u></div>";



export { backendUrl, isOnServer, onlyQuestions, supportInfo }